import { render, staticRenderFns } from "./MedicineForm.vue?vue&type=template&id=0c58e8f4&scoped=true&"
import script from "./MedicineForm.vue?vue&type=script&lang=ts&"
export * from "./MedicineForm.vue?vue&type=script&lang=ts&"
import style0 from "./MedicineForm.vue?vue&type=style&index=0&id=0c58e8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c58e8f4",
  null
  
)

export default component.exports